<template>
  <section>
    <v-card>
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          Points by which to evaluate a candidate (student).
        </v-alert>
      </v-card-text>
      <v-divider/>
      <v-card-text>
        <draggable v-model="tasks" @change="updatePositions">
          <transition-group>
            <v-alert v-for="task in tasks" :key="task.id" class="v-alert--outlined my-1">
              <v-text-field v-model="task.body" dense solo
                            @click:append-outer="destroy(task)"
                            @change="update(task)"
                            hide-details
                            :append-outer-icon="'mdi-delete'"/>
            </v-alert>
          </transition-group>
        </draggable>

<!--        <v-text-field v-for="(task, idx) in tasks" :key="idx"-->
<!--                      v-model="task.body" dense outlined-->
<!--                      @click:append-outer="destroy(task)"-->
<!--                      @change="update(task)"-->
<!--                      :append-outer-icon="'mdi-delete'"/>-->
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-text-field
            v-model="body"
            :append-outer-icon="'mdi-send'"
            filled
            clearable
            label="Task"
            type="text"
            @click:append-outer="create"
            @click:clear="clearCreateInput"
            @keyup.enter="create"
        ></v-text-field>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    tasks: [],
    body: ''
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tasks = await this.axios.get(`api/mocks/${this.$route.params.mock_id}/tasks`)
          .then(({data}) => data.data)
    },
    create() {
      if(this.body === '') return;
      this.api_errors = []
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/tasks`, {
        position: this.tasks.length,
        body: this.body
      })
          .then(({data}) => {
            this.tasks.push(data.data)
            this.clearCreateInput()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    },
    clearCreateInput() {
      this.body = ''
    },
    updatePositions() {
      this.tasks.map((item, idx) => {
        item.position = idx
        return item
      })

      this.tasks.forEach(item => {this.update(item)})
    },
    update(task) {
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/tasks/${task.id}`, task)
          .then(() => {this.$notify('Updated', 'success')})
    },
    destroy(task) {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}/tasks/${task.id}`)
          .then(() => {
            this.$notify('Deleted', 'success')
            this.loadData()
          })
    },
  }
}
</script>